
export let confirmationMessage: string;
export let confirmationTittle: string;
export let buttonActionClicked: string;

const confirmationState = {
  message: '',
  title: '',
  highlightedMessage: '',
};

export const setConfirmationMessage = (message: string) => {
  confirmationState.message = message;
};

export const setHighlightedConfirmationMessage = (message: string) => {
  confirmationState.highlightedMessage = message;
};

export const setConfirmationTittle = (title: string) => {
  confirmationState.title = title;
};

export const setButtonActionClicked = (action: string) => {
  buttonActionClicked = action;
};

// 👇 Add these getters to mimic previous exported variables
export const getConfirmationMessage = () => confirmationState.message;
export const getConfirmationTittle = () => confirmationState.title;
export const getHighlightedConfirmationMessage = () => confirmationState.highlightedMessage;
